import { useTheme } from 'styled-components';
import useDashboardController from '../../1_application/dashboard/dashboardController';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestContext, TestStatusDto } from '../../2_domain/test/test';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';
import BoxContainer from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXSelector from '../core/components/buttons/lxSelector';
import { XCenter } from '../core/components/center';
import LXError from '../core/error/lx_error';
import LXSpinner from '../core/spinner/lx_spinner';
import { LXh2 } from '../core/texts/lxText';
import DateRangeForm from './components/dateRangeForm';
import KlabPoster from './components/klabPoster';
import NewClient from './components/newClient';
import NewTest from './components/newTest';
import Notice from './components/notice';
import TestCompleted from './components/testCompleted';
import TestingProgress from './components/testingProgress';

const DashboardPage = ({
  statusDone,
  statusOthers,
}: {
  statusDone: TestStatusDto;
  statusOthers: TestStatusDto[];
}) => {
  const theme = useTheme();
  const d = useDashboardController(statusDone, statusOthers);

  return (
    <XCenter>
      <BoxContainer
        borderRadius="0"
        backgroundColor={theme.colors.grayBgLight}
        padding="0"
      >
        <SizedBox height={80}></SizedBox>
        <Column>
          {/** header */}
          <Row justifyContent="space-between">
            <LXh2>{theme.menus.dashboard}</LXh2>
            <LXSelector<string>
              dropdownItemWidth={180}
              value={d.rangeValue}
              labels={d.rangeOptions}
              values={d.rangeOptions}
              onSelect={d.changeRangeOption}
            ></LXSelector>
          </Row>
          <SizedBox height={16}></SizedBox>
          <DateRangeForm
            isDisplay={d.showRange}
            onApply={d.applyDateRange}
          ></DateRangeForm>
          <SizedBox height={31}></SizedBox>
          <Row flexGrow={1}>
            {/** left */}
            <Column flexGrow={1}>
              {/* error dashboard one start*/}
              <TestingProgress
                width={'304px'}
                height={'320px'}
                statusOthers={d.statusOthers}
                fromDate={d.fromDate}
                endDate={d.endDate}
              ></TestingProgress>
              <SizedBox height={24} />
              <NewClient
                width="304px"
                height="150px"
                fromDate={d.fromDate}
                endDate={d.endDate}
              ></NewClient>
              <SizedBox height={24} />
              <NewTest
                width="304px"
                height="150px"
                fromDate={d.fromDate}
                endDate={d.endDate}
              ></NewTest>
              {/* error dashboard one end */}
            </Column>
            <SizedBox width={24} />
            {/** right */}
            <Column flexGrow={1}>
              <TestCompleted
                width="632px"
                height="400px"
                fromDate={d.fromDate}
                endDate={d.endDate}
                statusDone={d.statusDone}
              ></TestCompleted>
              <SizedBox width={24}></SizedBox>
              <Row>
                <Notice width="304px" height="244px."></Notice>
                <SizedBox width={24}></SizedBox>
                <KlabPoster width="304px" height="244px"></KlabPoster>
              </Row>
            </Column>
          </Row>
        </Column>
      </BoxContainer>
    </XCenter>
  );
};

const DashboardPageWrapper = () => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');

  const testStatuses = wrapPromise<void, TestStatusDto[]>(
    testRepo.getTestStatuses,
    undefined,
    'testRepoKey'
  )();
  const statusDone = testStatuses.filter(
    (val) => val.context === TestContext.DONE
  )[0];
  const statusOthers = testStatuses.filter(
    (val) => val.context !== TestContext.DONE
  );
  return (
    <DashboardPage
      statusDone={statusDone}
      statusOthers={statusOthers}
    ></DashboardPage>
  );
};

export default withAsync({
  child: DashboardPageWrapper,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
